import { htmlEscape } from '@edicom/common/string/htmlEscape';

/**
 * Devuelve la cadena con las variables `{{ variable }}` reemplazada por su valor `params.variable`.
 *
 * @param {string} str la cadena a interpolar
 * @param {Object} [params={}] las variables que se van a interpolar
 * @returns {string} la cadena
 */
export function interpolate(str = '', params = {}) {
  if (typeof str === 'number') {
    str = `${str}`;
  }

  if (typeof str !== 'string' || str === '') {
    return '';
  }

  let start = str.indexOf('{{');
  if (start === -1) {
    return str;
  }

  let rest = str;
  let res = '';
  while (rest) {
    let cur = '';
    let end = 0;

    if (start === -1) {
      // si ya no quedan variables a interpolar
      // salimos del bucle
      res += rest;
      return res;
    } else if (start === 0) {
      // si el token es una variable, la interpolamos
      end = rest.indexOf('}}') + 2;
      const expression = rest.substring(start, end);
      cur = parse(expression, params);
    } else {
      // si el token es una cadena simple
      end = start;
      cur = rest.substring(0, end);
    }
    rest = rest.substring(end);
    res += cur;
    start = rest.indexOf('{{');
  }
  return res;
}

function parse(expression, params) {
  const name = expression.slice(2, -2).trim();
  return htmlEscape(params[name]) || '';
}
